import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import classNames from "classnames";
import Tooltip from "component/design-system/tooltip/Tooltip";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { Info } from "lucide-react";
import { useTranslation } from "next-i18next";
import ColorBox from "component/design-system/color-box/ColorBox";
import styles from "./final-sale-tag.module.scss";

interface IProps {
  product: ICompactProduct;
  // Positioning class supplied by the caller (e.g. the absolute placement used on the product page).
  className?: string;
  isStickyHeader?: boolean;
}

function FinalSaleTag({ product, className, isStickyHeader = false }: IProps) {
  const { t } = useTranslation();
  
  // Non-returnable products are sold as a "Final Sale".
  if (product?.filterableAttributes?.isReturnable !== false) {
    return null;
  }

  return (
    <ColorBox color="red" className={isStickyHeader ? styles.color_box : ""}>
      <Tooltip text={t("This is a final sale item. No returns or exchanges accepted")}>
        <div className={classNames(styles.final_sale_tag, className)}>
          <PAText
            fontSize={FONT_SIZE[0]}
            bold
          >
            {t("FINAL SALE")}

          </PAText>
        </div>

      </Tooltip>
    </ColorBox>
  );
}

export default FinalSaleTag;
